import React from 'react';
import FieldError from './FieldError';

interface FullNameInputProps {
    value: string;
    error: string;
    onChange: (value: string) => void;
    onBlur: () => void;
}

const FullNameInput: React.FC<FullNameInputProps> = ({ value, error, onChange, onBlur }) => (
    <div className="cf-field">
        <input
            type="text"
            className={`cf-input${error ? ' cf-input--error' : ''}`}
            placeholder="שם מלא"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBlur}
            id="cf-fullName"
        />
        <FieldError message={error} />
    </div>
);

export default FullNameInput;
